import type { TContent, TVisibilityWidgetsCondition } from '~/types/common';

export const getVisibilityWidgetsConditionByArticle = (
  article: any,
): TVisibilityWidgetsCondition[] => {
  const visibilityWidgetsCondition: TVisibilityWidgetsCondition[] = [];

  if (!article) {
    return visibilityWidgetsCondition;
  }

  visibilityWidgetsCondition.push({
    type: 'page',
    value: article.is_advertising || article.is_promo ? 'partner' : article.type,
  });

  article.categories.forEach((category: any) => {
    visibilityWidgetsCondition.push({
      type: 'category',
      value: category.id.toString(),
    });
  });

  article.tags.forEach((tag: any) => {
    visibilityWidgetsCondition.push({
      type: 'tag',
      value: tag.id.toString(),
    });
  });

  return visibilityWidgetsCondition;
};

/*
Логика работы

Одной фразой логику можно описать так: если срабатывает хотя бы одно из условий "Показывать, если" и
при этом не срабатывает ни одного из условий "Скрывать, если", то показываем виджет. В противном случае скрываем.

Пошагово оно работает так:

    Проверяем show
    Если в show ничего нет, то идём в пункт 2.
    Если в show что-то есть, то при срабатывании ХОТЯ БЫ ОДНОГО из условий идём в п.2.
    Если ни один не сработал - всё, НЕ ПОКАЗЫВАЕМ.

    Проверяем hide
    При срабатывании ХОТЯ БЫ ОДНОГО из условий в hide всё, НЕ ПОКАЗЫВАЕМ.

Всё. Если не наступило "НЕ ПОКАЗЫВАЕМ", то показываем.
 */
export const filterWidgetsByVisibilityWidgetsCondition = (
  visibilityWidgetsCondition: TVisibilityWidgetsCondition[],
): any => {
  return (widget: TContent): boolean => {
    const {
      attributes: { visibility },
    } = widget;

    if (!visibility) {
      return true;
    }

    if (visibility.show?.length) {
      let isConditionFulfilled: boolean = false;
      visibility.show.forEach((item: TVisibilityWidgetsCondition) => {
        visibilityWidgetsCondition.forEach((pageItem) => {
          if (item.type === pageItem.type && item.value === pageItem.value) {
            isConditionFulfilled = true;
          }
        });
      });

      if (!isConditionFulfilled) {
        return false;
      }
    }

    if (visibility.hide?.length) {
      let isConditionFulfilled: boolean = false;
      visibility.hide.forEach((item: TVisibilityWidgetsCondition) => {
        visibilityWidgetsCondition.forEach((pageItem) => {
          if (item.type === pageItem.type && item.value === pageItem.value) {
            isConditionFulfilled = true;
          }
        });
      });

      if (isConditionFulfilled) {
        return false;
      }
    }

    return true;
  };
};
